import { AbstractDTO } from '../abstract';

export class ComponentDTO extends AbstractDTO {
    compCode: string;
    compName: string;
    compAlt: string;
    compGroup: string;
    compGroupOrder: string;
    compExplain: string;
	image: string;
    exclusive: string;
    defaultName: string;
    productId: number;
    productCode: number;
    includePrice: boolean;
    includeBom: boolean;
	quantity: number;
	price: number;
    popupImage: string;
    url: string;

    constructor(attributes?: Object) {
        attributes = attributes ? attributes : {};
        super(attributes);

        this.compCode = attributes['comp_code_s'] || '';
        this.compName = attributes['comp_name_s'] || '';
        this.compAlt = attributes['comp_alt_s'] || '';
        this.compGroup = attributes['comp_group_s'] || '';
        this.compGroupOrder = attributes['comp_group_order_i'] || '';
        this.compExplain = attributes['comp_explain_s'] || '';
        this.image = attributes['product_pic_s'] || '';
        this.exclusive = attributes['comp_exclusive_s'] || '';
        this.defaultName = attributes['comp_default_name_s'] || '';
        this.productId = attributes['product_id_i'] || 0;
		this.productCode = attributes['product_code_s'];
        this.includePrice = attributes['comp_include_price_s'] == '1' ? true: false;
        this.includeBom = attributes['comp_include_bom_s'] == '1' ? true: false;
		this.quantity = attributes['comp_quantity_i'] || 1;
		this.price = attributes['comp_price_d'] || 0;
        this.popupImage = attributes['comp_popup_image_s'] || '';
        this.url = attributes['comp_url_s'] || '';
    }

}
